import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import App from 'components/layouts/App'; // Remove App wrap if you wish

const NoAuthRoute = ({ component, ...rest }) => (
  <Route
    exact
    {...rest}
    render={props =>
      !rest.authenticated ? (
        rest.app ? (
          <App title={rest.title}>{React.createElement(component, props)}</App>
        ) : (
          React.createElement(component, props)
        )
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default NoAuthRoute;
